// extracted by mini-css-extract-plugin
export default {"overlayTooltip":"DownloadTranscriptomics_overlayTooltip__QQB0x"};